import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Environment } from './environment.model';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}
const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1 ||
  window.navigator.userAgent.indexOf('Edge') > -1;

/**
 * This file will be replaced during prod build through the prebuild.js script.
 * That way, prod setting apply for deployed versions.
 */
export const environment: Environment = {
  production: false,
  azureEndpoint: 'https://test.api.schenck.one',
  apiBaseUrl: 'https://test.api.schenck.one/mc/v1', // against deployed/cloud backend
  amBaseUrl: 'https://test.api.schenck.one/am/v1', // against deployed/cloud backend
  usBaseUrl: 'https://test.api.schenck.one/user', //  for user settings api
  umBaseUrl: 'https://test.api.schenck.one/um/v2/rights/MC',
  apiVersion: '1.0',
  // DON'T change the following line! it will be replaced by a build-step with correct values
  versionInfo: {
    tag: 'test',
    hash: '44ab10627e4c0454625d15a5e09b898a171a806f',
    buildtimestamp: '2025-12-21T23:36:46.0861063Z',
    buildVersion: '2.0.0+1628',
  },
  msalConfig: {
    msal: {
      auth: {
        clientId: 'c7a2ce82-e2d3-4e7c-ab26-588ab27792cc',
        knownAuthorities: ['durrgroupb2c.b2clogin.com'],
        authority: 'https://durrgroupb2c.b2clogin.com/durrgroupb2c.onmicrosoft.com/B2C_1A_SIGNIN',
        redirectUri: 'https://test.machinecenter.schenck.one',
        postLogoutRedirectUri: 'https://test.machinecenter.schenck.one/postlogout',
      },
      cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: true, // set to true for IE 11. Remove this line to use Angular Universal
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false,
        },
      },
    },
    guard: {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [
          'https://durrgroupb2c.onmicrosoft.com/58a9657b-ab0c-45f2-8ae8-da25f14074a7/API.All',
        ],
      },
      loginFailedRoute: '/login-failed',
    },
  },
};
